import { Box, Group, Card, SimpleGrid, Text } from '@mantine/core';
import { utils } from "../../utils/globalVariables";
import { getValuePropInObj, numberWithComma, sqlDateToHumanDate } from "../../utils/globalFunctions";
import ModalWrapperWithoutFooter from "../general/ModalWrapperWithoutFooter";

const DiscountVoucherSelectorModal = ({ stateShow, fnShow, fnOnSelect, stateData }) => {
  return (
    <ModalWrapperWithoutFooter
      stateShow={stateShow}
      fnHide={fnShow}
      stateHideOnClickOutSide={true}
      stateTitle={String('Daftar Diskon Voucher').toUpperCase()}
      stateSize='md'
      stateOverlayZIndex={201}
      stateWithCloseButton={true}
    >
      {Array.isArray(stateData) && stateData.length > 0 &&
        <SimpleGrid
          cols={1}
          spacing='xs'
        >
          {Object.keys(stateData).map((key, index) => {
            return (
              <Card
                key={key}
                shadow=''
                radius="md"
                withBorder={true}

                sx={(tema) => ({
                  backgroundColor: stateData[key].diskon_flag === utils.discountFlag.discount.value ? tema.colors.blue[0] : tema.colors.orange[0],
                  overflow: 'unset',
                  cursor: 'pointer',
                  transition: '200ms',
                  '&:hover': {
                    backgroundColor: stateData[key].diskon_flag === utils.discountFlag.discount.value ? tema.colors.blue[1] : tema.colors.orange[1],
                  }
                })}

                onClick={() => fnOnSelect({
                  id: stateData[key].diskon_id,
                  flag: stateData[key].diskon_flag,
                  quota: stateData[key].diskon_quota,
                  name: stateData[key].diskon_code_prefix,
                  type: stateData[key].diskon_type,
                  value: stateData[key].diskon_value,
                  deductedFrom: stateData[key].diskon_deducted_from,
                  validDateFrom: stateData[key].diskon_valid_date_from,
                  validDateTo: stateData[key].diskon_valid_date_to,
                })}
              >
                <Card.Section p='sm'>
                  <Box>
                    <Group
                      position='apart'
                      sx={(tema) => ({
                        color: stateData[key].diskon_flag === utils.discountFlag.discount.value ? tema.colors.blue[9] : tema.colors.orange[9],
                        borderBottom: `1px dashed ${stateData[key].diskon_flag === utils.discountFlag.discount.value ? tema.colors.blue[9] : tema.colors.orange[9]}`
                      })}
                    >
                      <Text
                        size="sm"
                        pb='.5rem'
                        fw={500}
                      >
                        {getValuePropInObj(utils.discountFlag, 'value', stateData[key].diskon_flag, 'label', ' - ').toUpperCase()}
                      </Text>

                      <Text
                        size="sm"
                        pb='.5rem'
                        fw={500}
                      >
                        {stateData[key].diskon_flag === utils.discountFlag.voucher.value ? `${stateData[key].diskon_quota} Pcs` : ''}
                      </Text>
                    </Group>

                    <Box
                      sx={(tema) => ({
                        color: stateData[key].diskon_flag === utils.discountFlag.discount.value ? tema.colors.blue[6] : tema.colors.orange[6],
                      })}
                    >
                      <Text
                        size="sm"
                        fw={500}
                        mt='.5rem'
                      >
                        {stateData[key].diskon_code_prefix}
                      </Text>

                      <Text size="sm">
                        Potongan {stateData[key].diskon_type === utils.discountType.rupiah.value ? `Rp ${numberWithComma(Number(stateData[key].diskon_value))}` : `${Number(stateData[key].diskon_value)}%`} - {getValuePropInObj(utils.discountDeductedFrom, 'value', stateData[key].diskon_deducted_from, 'label', ' - ')}
                      </Text>

                      {stateData[key].diskon_flag === utils.discountFlag.voucher.value &&
                        <Text size="xs" mt='.5rem'>
                          {sqlDateToHumanDate({
                            stateDate: stateData[key].diskon_valid_date_from,
                            stateWithTime: false,
                            stateLang: 'id',
                            stateIsShort: true,
                            stateDay: false,
                            stateDefaultValue: ' - ',
                            stateDateType: 'day',
                            stateWithSecond: false
                          })}

                          {` - `}

                          {sqlDateToHumanDate({
                            stateDate: stateData[key].diskon_valid_date_to,
                            stateWithTime: false,
                            stateLang: 'id',
                            stateIsShort: true,
                            stateDay: false,
                            stateDefaultValue: ' - ',
                            stateDateType: 'day',
                            stateWithSecond: false
                          })}
                        </Text>
                      }
                    </Box>
                  </Box>
                </Card.Section>
              </Card>
            )
          })}
        </SimpleGrid>
      }

      {((Array.isArray(stateData) && (stateData.length <= 0)) || (!stateData)) &&
        <Text size='sm'>No Data</Text>
      }
    </ModalWrapperWithoutFooter>
  )
}

export default DiscountVoucherSelectorModal;